import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophone,
  faVideo,
  faDesktop,
  faVideoSlash,
  faMicrophoneSlash,
} from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";
import "./MeetingFooter.css";
const MeetingFooter = (props) => {
  const [streamState, setStreamState] = useState({
    mic: true,
    video: false,
    screen: false,
  });
  const micClick = () => {
    setStreamState((currentState) => {
      return {
        ...currentState,
        mic: !currentState.mic,
      };
    });
  };

  const onVideoClick = () => {
    setStreamState((currentState) => {
      return {
        ...currentState,
        video: !currentState.video,
      };
    });
  };

  const onScreenClick = () => {
    props.onScreenClick(setScreenState);
  };

  const setScreenState = (isEnabled) => {
    setStreamState((currentState) => {
      return {
        ...currentState,
        screen: isEnabled,
      };
    });
  };
  useEffect(() => {
    props.onMicClick(streamState.mic);
    // eslint-disable-next-line
  }, [streamState.mic]);

  useEffect(() => {
    props.onVideoClick(streamState.video);
    // eslint-disable-next-line
  }, [streamState.video]);

  const buttonsStyle = props.showParticipants ? { width: '7.93vw', height: '4.26vh' } : {}

  return (
    <div className="meeting-footer" style={{ background: 'transparent' }}>
      <div
        style={buttonsStyle}
        className={"microphone-icon meeting-icons " + (!streamState.mic ? "active" : "")}
        data-tip={streamState.mic ? "Mutar Audio" : "Desmutar Audio"}
        onClick={micClick}
      >
        <FontAwesomeIcon
          className="icon-microphone"
          icon={!streamState.mic ? faMicrophoneSlash : faMicrophone}
          title="Mute"
        />
      </div>

      <div
        style={buttonsStyle}
        className={"video-icon meeting-icons " + (!streamState.video ? "active" : "")}
        data-tip={streamState.video ? "Escoder vídeo" : "Mostrar Video"}
        onClick={onVideoClick}
      >
        <FontAwesomeIcon icon={!streamState.video ? faVideoSlash : faVideo} />
      </div>

      <div
        style={buttonsStyle}
        className="shared-icon meeting-icons"
        data-tip="Compartilhar tela"
        onClick={onScreenClick}
        disabled={streamState.screen}
      >
        <FontAwesomeIcon icon={faDesktop} />
      </div>

      <ReactTooltip />
    </div>
  );
};

export default MeetingFooter;
